import Vue from "vue";
import VueI18n from "vue-i18n";
import { getBrowserLocale, supportedLocalesInclude, removeEmptyTradKeys } from "../modules/utils";

const fr = require("../locales/fr.json");
const de = require("../locales/de.json");

Vue.use(VueI18n);

let locale = getBrowserLocale({ countryCodeOnly: true });
if (!supportedLocalesInclude(locale)) {
  locale = "fr";
}

export default new VueI18n({
  locale,
  fallbackLocale: "fr",
  messages: {
    fr: removeEmptyTradKeys(fr),
    de: removeEmptyTradKeys(de),
  },
});

export {
  fr,
  de,
};
